import React from "react";

import { FAQ_ITEMS } from "@/lib/constants/marketing-items";
import { HeaderSubheaderComponent } from "@/pages/partners/[partnerName]";

const Faqs = ({ faqs }: { faqs?: HeaderSubheaderComponent[] }) => {
  // if there are contentful faqs, use those
  // otherwise, use the default faqs

  const normalizedFaqs = faqs?.map((faq) => ({
    question: faq.fields.header,
    answer: faq.fields.subheader,
  }));

  const faqsToDisplay = normalizedFaqs || FAQ_ITEMS;

  return (
    <div className="bg-black text-white px-5 md:px-16 md:py-28 py-16">
      <div className="flex flex-col justify-between md:gap-10 gap-12 max-w-7xl mx-auto relative">
        <div className="flex flex-col gap-2 font-semibold max-w-3xl">
          <p>Support</p>
          <h1 className="font-clash font-semibold text-4xl md:text-5xl leading-[1.2] tracking-tight">
            Frequently Asked Questions
          </h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-x-10 w-full">
          {faqsToDisplay.map((item, index) => (
            <div key={index} className="flex flex-col gap-3 bg-white rounded-3xl px-6 py-5 text-black">
              <h4 className="font-semibold md:text-lg text-base leading-[1.1] tracking-tight">{item.question}</h4>
              <p className="md:text-base text-sm font-normal text-ash-700">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faqs;
